import { render } from "./TopNav.vue?vue&type=template&id=49fb9d15"
import script from "./TopNav.vue?vue&type=script&lang=js"
export * from "./TopNav.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Developer\\Desktop\\Company\\help-desk\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__